import { FC } from "react";

import Link from "next/link";

import { t } from "@lingui/macro";
import { Button, Modal, Result } from "antd";

const DownloadModal: FC<{ title: string; installUrl?: string; onClose: () => void }> = ({
  installUrl,
  title,
  onClose,
}) => {
  return (
    <Modal footer={null} destroyOnClose open={!!installUrl} onCancel={onClose}>
      <div style={{ paddingTop: 16 }}>
        {installUrl && (
          <Result
            status="success"
            title={t`File is ready`}
            extra={
              <Link target="_blank" href={installUrl}>
                <Button type="primary" style={{ margin: "auto" }}>{t`Download`}</Button>
              </Link>
            }
          />
        )}
      </div>
    </Modal>
  );
};

export default DownloadModal;
